module.exports = __webpack_public_path__ + "static/pl-rate-drop-2-957df58702808b06716e1bc1acc5866f.jpg";